import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';
import { PackageService } from '@services/packages/package.service';
import { EnvironmentService } from '@services/environment/environment.service';
import { Models } from '@ibexfusion/models';
import { ImageAssetsService } from '@services/assets/image-assets.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { ImageEditorV2Component } from '../../../../../components/image-editor-v2/image-editor-v2.component';

@Component({
    selector: 'edit-media-modal',
    templateUrl: './edit-media.component.html',
    styleUrls: ['./edit-media.component.scss'],
    providers: [ImageAssetsService],
    standalone: false
})

export class EditMediaComponent implements OnInit {
  @ViewChild('imageEditor') imageEditor: ImageEditorV2Component;
  asset;
  isInContent;
  public resourceTranslations: any;
  public generalTranslations: any;
  package;
  availablePlayouts = { ibextouch: 'ibexTouch', ibexsmart: 'ibexApp' };
  projects = [];
  loading = true;
  showOneToOne = false;
  showSixteenToNine = false;
  showWidget = false;
  showFourToThree = false;
  showFreeForm = true;
  oneToOne = {
    ibextouch: ['information', 'event', 'gallery', 'offer', 'opening-hours', 'restaurant', 'social-media', 'voucher', 'news', 'alphabet', 'person'],
    ibexsmart: ['event', 'restaurant', 'opening-hours', 'news', 'gallery', 'person', 'alphabet', 'offer', 'voucher']
  };
  sixteenToNine = {
    ibextouch: ['information', 'event', 'gallery', 'offer', 'opening-hours', 'restaurant', 'social-media', 'voucher', 'news'],
    ibexsmart: ['information', 'event', 'gallery', 'offer', 'opening-hours', 'restaurant', 'social-media', 'voucher', 'news']
  };
  fourToThree = {
    ibextablet: ['information', 'event', 'gallery', 'offer', 'opening-hours', 'restaurant', 'social-media', 'voucher', 'news'],
  };
  activeFormat = 'original';
  edit = false;
  imageAssetPath: any;
  timestamp = Date.now();
  boundImageAsset: Models.ImageAsset | any;
  freeFormClip: Models.ClippingInformation;
  sixteenToNineClip: Models.ClippingInformation;
  widgetSizeClip: Models.ClippingInformation | any;
  fourToThreeClip: Models.ClippingInformation | any;
  oneToOneClip: Models.ClippingInformation;
  formats = {
    oneToOne: { minWidth: 300, minHeight: 300 }, sixteenToNine: { minWidth: 704, minHeight: 396 }, widgetSize: { minWidth: 380, minHeight: 670 },
    fourToThree: { minWidth: 400, minHeight: 300 }, freeForm: { minWidth: 400, minHeight: 704 }
  };
  oneToOneData;
  sixteenToNineData;
  widgetSizeData;
  fourToThreeData;
  freeFormData;
  scale = 1;
  newImageData: any;
  visibility = 'hidden';
  titleUpdated = false;

  constructor(
    public dialogRef: MatDialogRef<EditMediaComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private ts: TranslateService, private packageService: PackageService,
    private environmentService: EnvironmentService, private imageAssetsService: ImageAssetsService, private snackbar: SnackbarService
  ) {
    for (let k of Object.keys(this.formats)) {
      this[k + 'Data'] = {
        clip: true, crop: false, fixedScale: true, crop_initX: 0, crop_initY: 0, minWidth: this.formats[k].minWidth, minHeight: this.formats[k].minHeight,
        imageDimension: { width: 0, height: 0 }, offsetRight: 0, offsetBottom: 0, factor: 1
      }
    }
    this.imageAssetPath = this.environmentService.getImageAssetPath();
  }

  async ngOnInit() {
    this.resourceTranslations = this.ts.get('resources');
    this.generalTranslations = this.ts.get('system');
    if (this.data.asset.resizeInformation) {
      this.boundImageAsset = this.data.asset;
      this.updateClips();
      this.ensureClip('freeForm', this.boundImageAsset.rawWidth, this.boundImageAsset.rawHeight);

      this.init();
      this.isInContent = this.data.isInContent;
    }
  }

  updateClips() {
    this.oneToOneClip = this.boundImageAsset.resizeInformation.oneToOne.clip;
    this.sixteenToNineClip = this.boundImageAsset.resizeInformation.sixteenToNine.clip;
    this.widgetSizeClip = this.boundImageAsset?.resizeInformation?.widgetSize?.clip;
    if (!this.widgetSizeClip) {
      this.widgetSizeClip = { height: 670, width: 380, offsetX: 0, offsetY: 0 };
    }
    this.fourToThreeClip = this.boundImageAsset?.resizeInformation?.fourToThree?.clip;
    if (!this.fourToThreeClip) {
      this.fourToThreeClip = { height: 300, width: 400, offsetX: 0, offsetY: 0 };
    }
  }

  ensureClip(type, width, height, offsetX = 0, offsetY = 0) {
    if (!this.boundImageAsset.resizeInformation[type] || !this.boundImageAsset.resizeInformation[type].clip) {
      const maxClip = new Models.ClippingInformation();
      maxClip.populateFromJSON({ width, height, offsetX, offsetY });
      this.boundImageAsset.resizeInformation[type] = new Models.ResizeInformationDetail();
      this.boundImageAsset.resizeInformation[type].clip = maxClip;
    } else {
      this[`${type}Clip`] = this.boundImageAsset.resizeInformation[type].clip;
    }
  }

  async init() {
    this.prepareImage();
    this.package = await this.packageService.get(window['forcePackage']);
    if (this.package) {
      this.projects = Object.keys(this.availablePlayouts).filter(type => {
        return !!(this.package?.devices?.length ? this.package?.devices?.includes(type) : !!this.package?.[this.availablePlayouts[type]]?.enabled);
      });
      if (this.data.page === 'content') {
        for (let i = 0; i < this.projects.length; i++) {
          if (this.oneToOne[this.projects[i]].includes(this.data.dataType)) {
            this.showOneToOne = true;
          }
          if (this.sixteenToNine[this.projects[i]].includes(this.data.dataType)) {
            this.showSixteenToNine = true;
          }
          if (this.fourToThree[this.projects[i]]?.includes(this.data.dataType)) {
            this.showFourToThree = true;
          }
        }
      } else if (this.data.page === 'navigation') {
        this.showFreeForm = false;
        this.data.dataType === 'thumbnail' ? this.showOneToOne = true : this.showWidget = true;
      } else if (this.data.page === 'images') {
        this.showOneToOne = false;
        this.showSixteenToNine = true;
        this.showWidget = false;
        this.showFourToThree = false;
        this.showFreeForm = false;
      } else {
        this.showOneToOne = true;
        this.showSixteenToNine = true;
        this.showWidget = true;
        this.showFourToThree = true;
      }
    } else {
      this.loading = false;
    }
  }

  prepareImage() {
    const container: any = document.querySelector('.image-preview-container');
    if (!container) {
      return setTimeout(() => { this.prepareImage(); }, 100);
    }
    let resizeInfo = this.get(this.activeFormat, 'clip');
    if (this.activeFormat === 'original' || !resizeInfo) {
      resizeInfo = { height: this.boundImageAsset.rawHeight, width: this.boundImageAsset.rawWidth, offsetX: 0, offsetY: 0 }
    }
    let scale = 1;
    if (container && resizeInfo) {
      const heightRatio =  400 / (resizeInfo.height);
      const widthRatio =  500 / (resizeInfo.width);
      if (heightRatio < 1 || widthRatio < 1) {
        scale = (heightRatio < widthRatio) ?  heightRatio : widthRatio;
      }
      container.style.setProperty('background-image', 'url(' + this.imageAssetPath + this.boundImageAsset.path + '/freeForm?t=' + this.timestamp + ')');
      container.style.setProperty('width', resizeInfo.width * scale  + 'px');
      container.style.setProperty('height', resizeInfo.height * scale + 'px');
      container.style.setProperty('background-size', this.boundImageAsset.rawWidth * scale + 'px ' + this.boundImageAsset.rawHeight * scale + 'px');
      container.style.setProperty('background-position-x', '-' + (resizeInfo.offsetX * scale) + 'px');
      container.style.setProperty('background-position-y', '-' + (resizeInfo.offsetY * scale) + 'px');
      const urlMatch = getComputedStyle(container).backgroundImage.match(/url\(["']?(.*?)["']?\)/);
      if (urlMatch && urlMatch[1]) {
        const image = new Image();
        image.src = urlMatch[1];
        image.onload = () => {
          if (image.naturalWidth > 0 && image.naturalHeight > 0) {
            this.visibility = 'visible';
            console.log('Background image successfully loaded');
          }
        };

        image.onerror = () => {
          console.log('Error loading background image');
        };
      } else {
        console.log('Background image not set or incorrect format');
      }
    } else {
      this.visibility = 'visible';
    }
  }

  openFormat(format) {
    this.edit = format !== 'original';
    this.newImageData = null;
    this.activeFormat = format;
    if (format === 'original') {
      this.prepareImage();
    }
  }

  save() {
    this.dialogRef.close(this.data.asset);
  }

  public get(type, variant) {
    return this[type + variant.charAt(0).toUpperCase() + variant.slice(1)];
  }

  cancelChanges() {
    if (this.newImageData) {
      this.newImageData = null;
      this.imageEditor.initSelectionBox();
    } else {
      this.dialogRef.close();
    }
  }

  onImageEditorChange(event) {
    this.newImageData = event;
  }

  onImageEditorSave(event) {
    if (event) {
      let offsetX = Math.floor(event.newClip.offsetX / event.newData.factor);
      offsetX = offsetX > 0 ? offsetX : 0;
      let offsetY = Math.floor(event.newClip.offsetY / event.newData.factor);
      offsetY = offsetY > 0 ? offsetY : 0;
      let width = Math.floor(event.newClip.width / event.newData.factor);
      width = offsetX + width <= this.boundImageAsset.rawWidth ? width : this.boundImageAsset.rawWidth - offsetX;
      let height = Math.floor(event.newClip.height / event.newData.factor);
      height = offsetY + height <= this.boundImageAsset.rawHeight ? height : this.boundImageAsset.rawHeight - offsetY;

      const newClip = { offsetX: offsetX, offsetY: offsetY, width: width, height: height };

      if (event.type === 'freeForm') {
        this.boundImageAsset.resizeInformation.freeForm.clip.populateFromJSON(newClip);
      } else if (event.type === 'sixteenToNine') {
        this.boundImageAsset.resizeInformation.sixteenToNine.clip.populateFromJSON(newClip);
      } else if (event.type === 'widgetSize') {
        if (!this.boundImageAsset.resizeInformation.widgetSize) {
          this.boundImageAsset.resizeInformation.widgetSize = {};
          this.boundImageAsset.resizeInformation.widgetSize.clip = {};
          this.boundImageAsset.resizeInformation.widgetSize.clip = newClip;
        } else {
          this.boundImageAsset.resizeInformation.widgetSize.clip.populateFromJSON(newClip);
        }
      } else if (event.type === 'fourToThree') {
        if (!this.boundImageAsset.resizeInformation.fourToThree) {
          this.boundImageAsset.resizeInformation.fourToThree = {};
          this.boundImageAsset.resizeInformation.fourToThree.clip = {};
          this.boundImageAsset.resizeInformation.fourToThree.clip = newClip;
        } else {
          this.boundImageAsset.resizeInformation.fourToThree.clip.populateFromJSON(newClip);
        }
      } else if (event.type === 'oneToOne') {
        this.boundImageAsset.resizeInformation.oneToOne.clip.populateFromJSON(newClip);
      } else if (event.type === 'listingBig') {
        this.boundImageAsset.resizeInformation.listingBig.clip.populateFromJSON(newClip);
      }
    }
    this.onSave();
  }

  titleUpdate() {
    this.titleUpdated = true;
  }

  async onSave() {
    const updateState = () => {
      this.timestamp = Date.now()
      this.newImageData = null;
      this.titleUpdated = false;
    }
    try {
      await this.imageAssetsService.update(this.boundImageAsset._id, this.boundImageAsset).then(async (res) => {
        this.data.asset = res;
        this.boundImageAsset = this.data.asset;
        this.updateClips();
        this.snackbar.success(this.generalTranslations.dynamicContent.saved, 5000);
        updateState();
      });
    } catch (err) {
      updateState();
      if ((err?.error?.message || '').startsWith('insufficient permission')) {
        this.snackbar.error(this.generalTranslations.general.failed + ': ' + err.error.message, 5000);
      }
    }
  }

  toggleEdit(showEdit) {
    this.edit = showEdit;
    if (!this.edit) {
      setTimeout(() => {
        this.prepareImage();
      }, 500)
    }
  }
}
